import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(@Inject(DOCUMENT) private document: Document, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const localStorage = this.document.defaultView?.localStorage;
    if (localStorage) {
      const tokens = this.document.defaultView?.localStorage.getItem("tokens");
      if (!tokens) {
        this.router.navigate(['/login']);
        return false;
      } 
     
    }
    return true;
  }
}
